<template>
  <div class="main-bas">
    <div class="title-jibne">实名认证</div>
    <div class="jigou">
      <div>认证类型:</div>
      <div>
        {{ isPersonal ? '个人' : '企业' }}
      </div>
    </div>
    <!-- 认证内容 -->
    <div class="nave">
      <div class="nave-lefr">
        <div>
          <div>ID:</div>
          <div>{{ realInformation.dciUserId }}</div>
        </div>
        <div>
          <div>名称:</div>
          <div>{{ realInformation.certName }}</div>
        </div>
        <div>
          <div>{{ isPersonal ? '身份证：' : '统一社会信用代码：' }}</div>
          <div>{{ realInformation.certificateNumber }}</div>
        </div>
        <div>
          <div>手机号：</div>
          <div>{{ realInformation.phone }}</div>
        </div>
        <div v-if="!isPersonal">
          <div>法人名称：</div>
          <div>{{ realInformation.legalPersonCertName }}</div>
        </div>
        <div>
          <div>状态：</div>
          <div class="xuigaimima">
            {{
              realInformation.errorMsg
                ? realInformation.errorMsg
                : getLabelByValue(realInformation.dciUserStatus, statusOptions)
            }}
          </div>
        </div>
      </div>
      <div>
        <div class="title-jibne-fsa">
          {{ isPersonal ? '身份证正面：' : '营业执照：' }}
        </div>
        <div class="asefsfdas" v-if="fileType">
          <div class="title-jibne-fsa">
            <file-preview
              :file-data="selectedFile"
              :fileType="fileType"
              style="width: 100%; height: 200px"
            ></file-preview>
          </div>
        </div>
      </div>
    </div>

    <!-- 提交注册 -->
    <el-row class="tijiao">
      <el-button
        type="primary"
        @click="resgInfo"
        :disabled="
          realInformation.dciUserStatus === 'NORMAL' ||
          realInformation.dciUserStatus === 'DISABLE' ||
          realInformation.dciUserStatus === 'PROCESSING' ||
          realInformation.dciUserStatus === 'TOBE_AUDIT'
        "
        >{{
          realInformation.certName ? '修改实名信息' : '认领实名信息'
        }}</el-button
      >
    </el-row>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      selectedFile: null,
      fileType: '',
      statusOptions: [
        {
          value: 'INIT',
          label: '未认证'
        },
        {
          value: 'NORMAL',
          label: '正常'
        },
        {
          value: 'DISABLE',
          label: '停用'
        },
        {
          value: 'PROCESSING',
          label: '认证中'
        },
        {
          value: 'TOBE_AUDIT',
          label: '人审中'
        },
        {
          value: 'FINISH',
          label: '认证成功'
        },
        {
          value: 'AUDIT_FAIL',
          label: '认证失败'
        },
        {
          value: 'EXPIRED',
          label: '证件已过期'
        }
      ]
    }
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    userInfo () {
      return this.$store.state.userInfo.user
    },
    // 计算属性绑定到Vuex store中的userInfo
    realInformation () {
      return this.$store.state.realInformation
    },
    isPersonal () {
      return this.realInformation.legalPersonCertName ? false : true
    }
  },
  async created () {},
  watch: {
    realInformation (newVal) {
      this.getFile()
    }
  },

  mounted () {
    if (this.realInformation.certificateFrontFileIdLocal) {
      this.getFile()
    }
  },
  methods: {
    resgInfo () {
      this.$router.push({
        path: '/RealnameAuthenticationDelog'
      })
    },
    getLabelByValue (value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : value
    },
    async getFile () {
      console.log(
        this.realInformation.certificateFrontFileIdLocal,
        'zzzzzzzzzz'
      )
      const res = await this.$download.file(
        this.realInformation.certificateFrontFileIdLocal
      )
      if (res) {
        this.selectedFile = res
        this.fileType =
          this.realInformation.certificateFrontFileIdLocal.split('/')[0]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-bas {
  padding-left: 50px;
}
.title-jibne {
  font-size: 14px;
  margin-bottom: 50px;
}
.jigou {
  display: flex;
  font-size: 14px;
  margin-bottom: 30px;

  :nth-child(1) {
    width: 150px;
  }
}

.xuigaimima {
  color: #169bd5;
}
.nave {
  display: flex;
  > div {
    flex: 1;
  }
  .nave-lefr {
    > div {
      display: flex;
      margin-top: 15px;
      :nth-child(1) {
        width: 150px;
      }
    }
  }
}
.title-jibne-fsa {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15xp;
}
.tijiao {
  margin-top: 50px;
}

.asefsfdas {
  width: 300px;
  height: 200px;
}
</style>
